import { useParams } from 'react-router-dom';
import { useCustomNavigate, useDesign } from '@app/hooks';
import { IntentDetails, IntentDetailsMode } from '@app/page-components/modals';

export function ViewIntentPage() {
  const { id } = useParams<{ id: string; }>();
  const design = useDesign();
  const navigate = useCustomNavigate();
  const intent = design.components.intents.find((i) => i.id === id);

  if (!intent) {
    navigate('intents/management');
    return null;
  }

  return (
    <IntentDetails
      intent={intent}
      mode={IntentDetailsMode.view}
      onComplete={() => {
        navigate('intents/management');
      }}
    />
  );
}
